export const taskCenter = {
  syrw: 'Bắt ​​đầu với nhiệm vụ và kết thúc với bạn',
  zjlbt: 'Biking tiền thưởng USDT sẽ không dừng lại',
  wdjj: 'tiền thưởng của tôi',
  rwsm: 'Mô tả nhiệm vụ',
  rwlb: 'Danh sách nhiệm vụ',
  jljl: 'Kỷ lục phần thưởng',
  klq: 'Có sẵn để sưu tập:',
  flzm: 'Biking cổng phúc lợi',
  dcjl: 'Nhận phần thưởng USDT ngay khi bạn đạt được nó và đồng hành cùng bạn trên mọi chặng đường',
  yjlq: 'Bộ sưu tập chỉ bằng một cú nhấp chuột',
  lqcg: 'Đã nhận thành công',
  wdl: 'Chưa đăng nhập',
  jxz: 'đang tiến hành',
  ylq: 'Đã nhận',
  rwjd: 'Tiến trình nhiệm vụ',
  xsrw: 'Nhiệm vụ mới',
  hyrw: 'Nhiệm vụ hợp đồng',
  cjrz: 'Chứng chỉ cấp dưới',
  gjrz: 'Xác thực nâng cao',
  scbbjy: 'Giao dịch tiền xu đầu tiên',
  schyjy: 'Giao dịch hợp đồng đầu tiên',
  sccz: 'Nạp tiền lần đầu',
  schyhz: 'Chuyển hợp đồng đầu tiên',
  jyl: 'Khối lượng giao dịch',
  ylje: 'Số tiền lãi',
  ksje: 'số tiền thua lỗ',
  dbkcbzj: 'Lề mở đơn',
  rjl: 'Số tiền gửi',
  dbczje: 'Số tiền nạp một lần',
  rwxq: 'Chi tiết nhiệm vụ'
}


// WEBPACK FOOTER //
// ./src/i18n/lang/task/vi.js